<template>
  <div class="contact-page" id="app">
    <headerView :seletedindex="seletedindex" />

    <!-- 顶部横幅 -->
    <div
      class="banner"
      :style="{
        backgroundImage:
          'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(' +
          contactUsBanner.imgUrl +
          ')',
      }"
    >
      <div class="banner-content">
        <h1>{{ contactUsBanner.title }}</h1>
        <p>{{ contactUsBanner.subTitle }}</p>
      </div>
    </div>

    <!-- 职位基本信息 -->
    <div class="job-info-section">
      <div class="job-info-content">
        <h2 class="job-name">{{ jobName }}</h2>
        <div class="job-location">
          <i class="el-icon-location-outline"></i>
          <span>{{ jobLocation }}</span>
        </div>
        <div class="job-salary">
          <i class="el-icon-money"></i>
          <span>{{ jobSalary }}</span>
        </div>
      </div>
    </div>

    <!-- 职位详情中间部分 -->
    <div class="job-detail-section">
      <div class="detail-content" v-html="jobContent"></div>
    </div>

    <footerView />
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, jobDetails } from "@/api/index";

export default {
  name: "JobDetail",
  components: {
    headerView,
    footerView,
  },
  data() {
    return {
      seletedindex: 6,
      contactUsBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      jobName: "",
      jobLocation: "",
      jobSalary: "",
      jobContent: "",
    };
  },
  created() {
    this.$nextTick(() => {
      this.getcontactUsBanner();
      this.getjobDetails(this.$route.params.id);
    });
  },
  methods: {
    async getcontactUsBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 24 });
      if (res && res.length > 0) {
        this.contactUsBanner = res[0];
      }
    },
    async getjobDetails(id) {
      const res = await jobDetails("/api/zaoying/recruitments/detail", {
        id: id,
      });
      console.log(res);
      if (res) {
        this.jobName = res.zhiweimingcheng;
        this.jobSalary = res.xinzi;
        this.jobLocation = res.gongzuodidian;
        this.jobContent = res.content;
      }
    },
  },
};
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background-color: #fff;
}

.banner {
  background-size: cover;
  background-position: center;
  height: 25vw;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner h1 {
  font-size: 42px;
  margin-bottom: 25px;
  font-weight: 500;
}

.banner p {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

/* 职位基本信息样式 */
.job-info-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto 0;
  padding: 0 20px;
}

.job-info-content {
  background-color: #f8f9fa;
  padding: 40px;
  border-radius: 8px;
}

.job-name {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  text-align: left;
}

.job-location,
.job-salary {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
  text-align: left;
}

.job-location i,
.job-salary i {
  font-size: 18px;
  color: #1890ff;
  margin-right: 8px;
}

.job-location:last-child,
.job-salary:last-child {
  margin-bottom: 0;
}

/* 职位详情中间部分样式 */
.job-detail-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.detail-content {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  text-align: left;
}

.detail-content :deep(.detail-section) {
  margin-bottom: 50px;
}

.detail-content :deep(.detail-section:last-child) {
  margin-bottom: 0;
}

.detail-content :deep(.section-title) {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.detail-content :deep(.title-bar) {
  display: inline-block;
  width: 4px;
  height: 24px;
  background-color: #1890ff;
  flex-shrink: 0;
}

.detail-content :deep(.detail-list) {
  list-style: none;
  padding: 0;
  margin: 0;
}

.detail-content :deep(.detail-list li) {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
  padding-left: 0;
}

.detail-content :deep(.detail-list li:last-child) {
  margin-bottom: 0;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .job-info-section {
    margin: 40px auto 0;
    padding: 0 20px;
  }

  .job-info-content {
    padding: 30px 20px;
  }

  .job-name {
    font-size: 24px;
    margin-bottom: 15px;
  }

  .job-location,
  .job-salary {
    font-size: 14px;
    margin-bottom: 10px;
  }

  .job-detail-section {
    margin: 40px auto;
    padding: 0 20px;
  }

  .detail-content :deep(.section-title) {
    font-size: 20px;
  }

  .detail-content :deep(.detail-list li) {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .banner {
    height: 50vw;
  }
}
</style>

